import { MenuItemType } from '@/modules/common/layout/models/types/MenuItem'
import route from 'ziggy-js'

export function panelMenuStoreItems(userBootUseCase): Array<MenuItemType> {
  let items = [
    {
      id: 'dashboard',
      name: 'داشبورد',
      icon: 'ion grid-outline',
      regex: '^/panel.*$',
      path: route('panel.dashboard')
    },
    {
      id: 'content-create',
      name: 'سفارش محتوا',
      icon: 'ion cart-outline',
      regex: '^/panel/content/create(\/)?(.*)$',
      path: route('panel.content.campaigns.create')
    },
    {
      id: 'content-items',
      name: 'محتواهای من',
      icon: 'ion file-tray-full-outline',
      regex: '^/panel/content/items(\/)?(.*)$',
      path: route('panel.content.items.index')
    },
    {
      id: 'content-campaigns',
      name: 'کمپین‌های من',
      icon: 'ion file-tray-stacked-outline',
      regex: '^/panel/content/campaigns(\/)?(.*)$',
      path: route('panel.content.campaigns.index')
    },
    {
      id: 'financial',
      name: 'مالی ',
      icon: 'ion receipt-outline',
      regex: '^/panel/financial.*$',
      children: [
        {
          id: 'invoices',
          name: 'صورتحساب ها',
          regex: '^/panel/financial/invoices.*$',
          path: route('panel.financial.invoices.index')
        },
        {
          id: 'wallet',
          name: 'شارژ کیف پول',
          regex: '^/panel/wallet.*$',
          path: route('panel.wallet.index')
        }
      ]
    },
    {
      id: 'support',
      name: 'پشتیبانی ',
      icon: 'ion support',
      regex: '^/panel/support.*$',
      children: [
        {
          id: 'tickets',
          name: 'تیکت ها',
          regex: '^/panel/support/tickets(\/)?(.*)$',
          path: route('panel.support.tickets.index')
        },
        {
          id: 'faq',
          name: 'سوالات متداول',
          regex: '^/panel/support/faqs(\/)?(.*)$',
          path: route('panel.support.faqs.index')
        }
      ]
    }
  ]

  // @ts-ignore
  return items
}